import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
})
export class AlertComponent {
  @Input() message: string;
  @Input() type: 'info' | 'warning' | 'danger' = 'danger';

  get icon(): string {
    switch (this.type) {
      case 'info':
        return 'info-circle';
      case 'warning':
      case 'danger':
        return 'exclamation-triangle';
    }
  }
}
